<template>
  <div>
    <modalDefault :showModal="showModal" @close="close()" @confirm="confirm()" modalText="幸运饰品规则" :showCancel="false"
      :showConfirm="false">
      <template #dialogContent>
        <div class="buy-box">
          <div class="buy-back">
            <p v-for="(item, index) in rule" :key="index">{{ item }}</p>
          </div>

        </div>
      </template>
    </modalDefault>
  </div>
</template>
<script>
import modalDefault from "@/components/common/modalDefault.vue";
export default {
  name: "modalRule",
  components: {
    modalDefault,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    rule: {
      type: Array,
      default: [],
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
<style lang="scss" scoped>
.buy-box {
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  .buy-back {
    background-color: #032E69;
    width: 100%;
    border-radius: 8px;
    padding: 15px;

    p {
      line-height: 20px;
    }
  }
}
</style>